// ** Core Layout Import

// !Do not remove the Layout import
import Layout from "@layouts/VerticalLayout";

// ** Menu Items Array
import navigation from "@src/navigation/vertical";
import navigationEvents from "@src/navigation/verticalEvent";
import navigationAttendees from "@src/navigation/verticalAttendees";
import { useSelector } from "react-redux";

const VerticalLayout = (props) => {
  const { switchNav } = useSelector((state) => state.globalConst);

  const navigationEvent = navigationEvents();
  const firstNavigation = navigation();
  const attendeesnav = navigationAttendees();
  let menuData;

  if (switchNav) {
    menuData = firstNavigation;
  } else {
    menuData = navigationEvent;
  }

  return (
    <Layout menuData={menuData} {...props}>
      {props.children}
    </Layout>
  );
};

export default VerticalLayout;
